import React from 'react';

function RenderMatCounsellingData({ data }) {
  return (
    <>
      {data?.procName && (
        <div>
          <div className="cntnt-blk prgrs-vw-blk content-line-break">
            <div className="assmnt-nt-rw-lft demosec tp-top-sec-val">
              <div className="assmnt-nt-rw">
                <span className="left assmnt-nt-lbl">Provider:</span>
                <span className="left assmnt-nt-val">{data?.providerName}</span>
              </div>
              <div className="assmnt-nt-rw">
                <span className="left assmnt-nt-lbl">Resource:</span>
                <span className="left assmnt-nt-val">{data?.resourceName}</span>
              </div>

              <div className="assmnt-nt-rw">
                <span className="left assmnt-nt-lbl">Date:</span>
                <span className="left assmnt-nt-val">{data?.therapyDate}</span>
              </div>

              <div className="assmnt-nt-rw">
                <span className="left assmnt-nt-lbl">Procedure :</span>
                <span className="left assmnt-nt-val">{data?.procName}</span>
              </div>
              {/* <div className="assmnt-nt-rw">
                <span className="left assmnt-nt-lbl">Select Problem:</span>
                <span className="left assmnt-nt-val">
                  <span
                    dangerouslySetInnerHTML={{ __html: data?.selectProblem }}
                  />
                </span>
              </div> */}
              <div className="assmnt-nt-rw">
                <span className="left assmnt-nt-lbl">Review in:</span>
                <span className="left assmnt-nt-val bold">
                  {data?.review_in} ({data?.review_date})
                </span>
              </div>
              <div className="assmnt-nt-rw">
                <span className="left assmnt-nt-lbl">Treatment duration:</span>
                <span className="left assmnt-nt-val">
                  {data?.treatment_duration}
                </span>
              </div>
              <div className="assmnt-nt-rw">
                <span className="left assmnt-nt-lbl">Treatment mode:</span>
                <span className="left assmnt-nt-val">
                  {data?.treatment_mode}
                </span>
              </div>
              <div className="assmnt-nt-rw">
                <span className="left assmnt-nt-lbl">Start date:</span>
                <span className="left assmnt-nt-val">{data?.start_date}</span>
              </div>
            </div>
          </div>
          <div className="cntnt-blk prgrs-vw-blk">
            <div className="left assmnt-nt-hdng">
              <span className="left">Problem:</span>
            </div>
            <div className="assmnt-nt-rw">
              <span className="left assmnt-nt-val width100">
                <span
                  dangerouslySetInnerHTML={{ __html: data?.selectProblem }}
                />
              </span>
            </div>
          </div>
          <div className="cntnt-blk prgrs-vw-blk">
            <div className="left assmnt-nt-hdng">
              <span className="left">Presenting Problem:</span>
            </div>
            <div className="assmnt-nt-rw">
              <span className="left assmnt-nt-val width100">
                <span
                  dangerouslySetInnerHTML={{ __html: data?.PresentingProblem }}
                />
              </span>
            </div>
          </div>
          <div className="cntnt-blk prgrs-vw-blk">
            <div className="left assmnt-nt-hdng">
              <span className="left">Behavior:</span>
            </div>
            <div className="assmnt-nt-rw">
              <span className="left assmnt-nt-val width100">
                <span dangerouslySetInnerHTML={{ __html: data?.behavior }} />
              </span>
            </div>
            {/* <div className="assmnt-nt-rw clear5">
              <span className="left assmnt-nt-lbl">Treatment duration:</span>
              <span className="left assmnt-nt-val">
                {data?.treatment_duration}
              </span>
            </div>
            <div className="assmnt-nt-rw clear5">
              <span className="left assmnt-nt-lbl">Treatment mode:</span>
              <span className="left assmnt-nt-val">{data?.treatment_mode}</span>
            </div>
            <div className="assmnt-nt-rw clear5">
              <span className="left assmnt-nt-lbl">Start Date:</span>
              <span className="left assmnt-nt-val">
                {data?.start_datestart_date}
              </span>
            </div> */}
          </div>
        </div>
      )}
    </>
  );
}

export default RenderMatCounsellingData;
